import React from 'react';
import SubCategory from './SubCategory';
import {RainbowContainer, ColorLine} from './styles';

const CategoryArts = ({isSubpage, isCategoryPage, location, lang}) => (
  <>
    <RainbowContainer>
      <ColorLine color="#a3c0c0" isSubpage={isSubpage}>
        {isSubpage && (
          <>
            <SubCategory
              to={`/${lang}/about-1`}
              name={lang === 'pl' ? 'CEL MUZEUM' : "MUSEUM'S MISSION"}
              color="#a3c0c0"
              isCategoryPage={isCategoryPage}
            />
          </>
        )}
      </ColorLine>
      <ColorLine color="#e09087" isSubpage={isSubpage}>
        {isSubpage && (
          <>
            <SubCategory
              to={`/${lang}/about-2`}
              name={lang === 'pl' ? 'TWÓRCY MUZEUM' : 'MUSEUM CREATORS'}
              color="#e09087"
              isCategoryPage={isCategoryPage}
            />
          </>
        )}
      </ColorLine>
      <ColorLine color="gray" style={{width: '164px'}} noMobile />
      <ColorLine color="#e0c887" isSubpage={isSubpage}>
        {isSubpage && (
          <>
            <SubCategory
              to={`/${lang}/about-3`}
              name={
                lang === 'pl' ? 'PATRONATY I PARTNERZY' : 'PARTNERS AND PATRONS'
              }
              color="#e0c887"
              isCategoryPage={isCategoryPage}
            />
          </>
        )}
      </ColorLine>
      <ColorLine color="#afa3c0" isSubpage={isSubpage}>
        {isSubpage && (
          <>
            <SubCategory
              to={`/${lang}/about-4`}
              name={lang === 'pl' ? 'BIBLIOGRAFIA' : 'BIBLIOGRAPHY'}
              isCategoryPage={isCategoryPage}
              color="#afa3c0"
            />
          </>
        )}
      </ColorLine>
    </RainbowContainer>
  </>
);

export default CategoryArts;
